import {
  ChartWidgetType,
  PieChartWidgetType,
} from '@baserow/modules/vokalisDashboard/widgetTypes'

export default defineNuxtPlugin({
  name: 'vokalis-dashboard',
  dependsOn: ['dashboard'],
  setup(nuxtApp) {
    const { $registry } = nuxtApp
    const context = { app: nuxtApp }

    $registry.register('dashboardWidget', new ChartWidgetType(context))
    $registry.register('dashboardWidget', new PieChartWidgetType(context))
  },
})
